import React from 'react';
import { Trans } from '@lingui/macro';
import { useParams } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import UpdateModelForm from 'components/models/UpdateModelForm';

const UpdateModelPage = props => {
  const { id } = useParams();

  return (
    <>
      <Container disableGutters>
        <Typography>
          <Trans id="models.useForm.edit">
            Atualizar o formulário para editar o modelo.
          </Trans>
        </Typography>
      </Container>
      <Container maxWidth="sm" disableGutters>
        <Box pt={4} display="flex" flexDirection="column">
          <UpdateModelForm model={id} />
        </Box>
      </Container>
    </>
  );
};

export default React.memo(UpdateModelPage);
